const seedersLean = (state) => {
  return collect(state.seeders).map(item => {
    return {id: item.id, name: item.name}
  }).all()
}


export default {
  seedersLean
}



// WEBPACK FOOTER //
// ./src/features/Seeder/store/getters.js